import { $delegate, $qs } from 'fxdom/es';
import { go } from 'fxjs/es';
import { UtilS } from '../../../../../../Util/S/Function/module/UtilS.js';
import { MShopAppMypageAccountMuiS } from '../../S/Mui/module/MShopAppMypageAccountMuiS.js';
import { MShopAppMypageAccountF } from '../Function/module/MShopAppMypageAccountF.js';
import { Header } from '@services/MarppleShop/renderApp/components/cells/Header/Global/Header.ts';
import { LayoutView } from '../../../../../../../services/MarppleShop/renderApp/components/cells/Layout/LayoutView.ts';
import { InputText } from '../../../../../../../services/MarppleShop/renderApp/components/atoms/Input/InputText.ts';
import { InputNumber } from '../../../../../../../services/MarppleShop/renderApp/components/atoms/Input/InputNumber.ts';
import { ButtonAction } from '../../../../../../../services/MarppleShop/shared/components/atoms/ButtonAction/ButtonAction.ts';
import { MShopUtilF } from '../../../../../Util/F/Function/module/MShopUtilF.js';

/*
 * 프론트에서 사용될 tab 옵션입니다.
 * https://www.notion.so/marpple/Marpple-UI-80875a30a63e436382a02e2d820f4695#2fecac9aa5f8457c92fa359c5ac71ef8
 * */
export const tab = {
  ...MShopAppMypageAccountMuiS.tab,

  inner_scroll_target: '', // modal 일때 이너 스크롤 엘리먼트 셀렉터

  makeData(tab) {}, // template 함수 인자에 들어갈 값을 리턴하는 함수,

  appending(tab_el) {}, // tab 엘리먼트가 만들어지면 울리는 함수
  appended(tab_el) {}, // tab 엘리먼트가 html에 붙으면 울리는 함수
  showing(tab_el) {}, // tab 엘리먼트 show하기 전 울리는 함수
  showed(tab_el) {}, // tab 엘리먼트 show하고 나서 울리는 함수
  rendered(tab_el) {
    const is_nbox = UtilS.isNboxApp();

    const modify_button_element = $qs('.my-account__btn_modify');
    MShopUtilF.hydrationRune(Header, LayoutView, InputText, InputNumber);
    const modify_button_view = modify_button_element && ButtonAction.createAndHydrate(modify_button_element);

    const trimToNumber = (e) => {
      e.target.value = e.target.value.replaceAll(/[^0-9]/g, '');
    };

    return go(
      tab_el,
      $delegate('click', '.my-account__btn_change_email', MShopAppMypageAccountF.changeEmail),
      $delegate('click', '.my-account__btn_change_pw', MShopAppMypageAccountF.changePassword),
      $delegate('click', '.my-account__btn_modify', MShopAppMypageAccountF.modify),
      $delegate('change', '.my-account__change-name-input', (e) => {
        const type = e.target.value.trim() ? 'white' : 'disabled';
        modify_button_view.data.type = type;
        modify_button_view.redraw();
      }),
      $delegate('change', '.my-account__change-birthday-input', trimToNumber),
      $delegate('input', '.my-account__change-birthday-input', trimToNumber),
      $delegate('change', '.my-account__change-phone-input', trimToNumber),
      $delegate('input', '.my-account__change-phone-input', trimToNumber),
      $delegate(
        'change',
        '.my-account__profile_image input[name="file"]',
        is_nbox
          ? MShopAppMypageAccountF.changeProfileImage
          : MShopAppMypageAccountF.changeProfileImageWithFetch,
      ),
      $delegate(
        'click',
        '.my-account__profile_image__delete',
        is_nbox
          ? MShopAppMypageAccountF.deleteProfileImage
          : MShopAppMypageAccountF.deleteProfileImageWithFetch,
      ),
      $delegate('click', '.my-account__btn_profile_modify', MShopAppMypageAccountF.profileModify),
      $delegate('click', '.my-account__btn_modify--nexon', MShopAppMypageAccountF.moveToNexonForModify),
    );
  }, // tab 에 관련된 모든 메소드와 엘리먼트 작업이 끝날때 울리는 함수

  hiding(tab_el, v) {}, // tab이 가려지기 전 울리는 함수
  hided(tab_el, v) {}, // tab이 가려진 후 울리는 함수
  removing(tab_el, v) {}, // tab이 삭제되기 전 울리는 함수
  removed(tab_el, v) {}, // tab이 삭제된 후 울리는 함수

  infinite(tab_el) {}, // tab 엘리먼트에 무한스크롤을 사용할때 쓰는 함수, 사용시 반드시 return MuiF.tabInfinite(...)
};
